import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Dashboard from './pages/Dashboard';
import Login from "./pages/Login";
import MealsCalendar from "./pages/MealCalendar";
import PurchaseOrderView from './pages/PurchaseOrderView'
import PublicRoute from "./utils/PublicRoute";
import PrivateRoute from "./utils/PrivateRoute";
import DashboardForSupplier from "./pages/DashboardForSupplier";
import MenuList from "./pages/MenuList";
import SupplierList from "./pages/SupplierList";
import PurchaseOrderByDate from "./pages/PurchaseOrderByDate";
import PurchaseOrderList from "./pages/PurchaseOrderList";
import PurchaseOrderListForSupplier from "./pages/POListSupplier";
import NotFound from "./pages/NotFound";
function App() {
  return (  
    <Router> 
      <Switch>
        <PublicRoute exact path="/" component={Login} />
        <PrivateRoute exact path="/dashboard" component={Dashboard} />
        <PrivateRoute exact path="/menu/list" component={MenuList} />
        <PrivateRoute exact path="/po/list" component={PurchaseOrderList} />
        <PrivateRoute exact path="/supplier/list" component={SupplierList} />
        <PrivateRoute exact path="/calendar/:idhotel" component={MealsCalendar} />
        <PrivateRoute exact path="/$2a$12$9S4H3D1Q7S9VWVYhxnfOjOEjKt9pIURhsrlagKUS4MRYt29h96x4O/supplier" component={DashboardForSupplier} />
        <PrivateRoute exact path="/po/list/$2a$12$9S4H3D1Q7S9VWVYhxnfOjOEjKt9pIURhsrlagKUS4MRYx9h96x4O" component={PurchaseOrderListForSupplier} />
        <PrivateRoute exact path="/purchase/order/:IDhotel/:IDbanquet/:dateEvent" component={PurchaseOrderView} />
        <PrivateRoute exact path="/purchase/order/bydate/:IDhotel/:IDSupplier/:dateEvent" component={PurchaseOrderByDate} />
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
}

export default App;


